import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SurfCruiseCriteriaService {
  private message = new BehaviorSubject(false);
  sharedMessage = this.message.asObservable();

  constructor() { }

  nextMessage(message: boolean) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-cruise-criteria/src/lib/surf-cruise-criteria.service.ts.SurfCruiseCriteriaService.nextMessage');
    this.message.next(message);
  }
}
